'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _ContextMenuItem = require('../Context/ContextMenuItem');

var _ContextMenuItem2 = _interopRequireDefault(_ContextMenuItem);

var _DropdownReactContext = require('./DropdownReactContext');

var _DropdownReactContext2 = _interopRequireDefault(_DropdownReactContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownMenuItem = function (_Component) {
  _inherits(DropdownMenuItem, _Component);

  function DropdownMenuItem(props) {
    _classCallCheck(this, DropdownMenuItem);

    var _this = _possibleConstructorReturn(this, (DropdownMenuItem.__proto__ || Object.getPrototypeOf(DropdownMenuItem)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(DropdownMenuItem, [{
    key: 'handleClick',
    value: function handleClick(event) {
      var closeDropdown = this.context.closeDropdown;
      var _props = this.props,
          multiSelect = _props.multiSelect,
          keepOpen = _props.keepOpen,
          onClick = _props.onClick;


      if (closeDropdown && !multiSelect && !keepOpen) closeDropdown();

      if (onClick) onClick(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          rest = _objectWithoutProperties(_props2, ['children']);

      return _react2.default.createElement(
        _ContextMenuItem2.default,
        _extends({}, (0, _lodash2.default)(rest, ['keepOpen']), {
          onClick: this.handleClick,
          tabIndex: '0' }),
        children
      );
    }
  }]);

  return DropdownMenuItem;
}(_react.Component);

DropdownMenuItem.propTypes = {
  /** SKIP */
  children: _propTypes2.default.node,
  /** Disabled interactions and applies styling */
  disabled: _propTypes2.default.bool,
  /**
   * Whether the menu should stay open after being clicked.
   */
  keepOpen: _propTypes2.default.bool,
  /**
  * Whether the menu is part of a multi-selection menu. When true, this
  * will disable automatically closing the DropdownMenu when clicked.
  */
  multiSelect: _propTypes2.default.bool,
  /** Click handler  */
  onClick: _propTypes2.default.func,
  /**  Vertical padding size applied to the menu item */
  paddingVertical: _propTypes2.default.oneOf(['small', 'medium']),
  /** Provides indication that the menu item is selected */
  selected: _propTypes2.default.bool
};
DropdownMenuItem.contextType = _DropdownReactContext2.default;
exports.default = DropdownMenuItem;